// @ts-check
// src/stores/dashboard.js — Sesja 3.6 — Dashboard state in Nanostores

import { atom } from 'nanostores';

/** Lista aktualizacji wyświetlanych w widgetcie dashboardu */
export const $dashboardUpdates = atom(/** @type {any[]} */ ([]));

/** Limit elementów do wyświetlenia (paginacja "pokaż więcej") */
export const $dashboardUpdatesLimit = atom(5);

/** Aktualnie rozwinięty element listy aktualizacji */
export const $dashboardUpdatesExpandedId = atom(/** @type {any} */ (null));

/** Lista wpisów admin updates (ustawienia → dziennik aktualizacji) */
export const $adminUpdatesList = atom(/** @type {any[]} */ ([]));

if (typeof window !== 'undefined') {
  /** @type {any} */ (window).__sbStores = Object.assign(/** @type {any} */ (window).__sbStores || {}, {
    $dashboardUpdates,
    $dashboardUpdatesLimit,
    $dashboardUpdatesExpandedId,
    $adminUpdatesList,
  });
}
